function BoundKnapSack({ values, weights = values.map((v) => v.value), n = values.length - 1, target, lookup = /* @__PURE__ */ new Map() }) {
	if (target < 0) return {
		values: [],
		total: Number.MIN_SAFE_INTEGER
	};
	if (n < 0 || target === 0) return {
		values: [],
		total: 0
	};
	const key = `${n}|${target}`;
	if (!lookup.has(key)) {
		const include = {
			values: [values[n]],
			total: values[n].value
		};
		{
			const temp = BoundKnapSack({
				lookup,
				values,
				weights,
				n: n - 1,
				target: target - weights[n]
			});
			include.values = include.values.concat(temp.values);
			include.total += temp.total;
		}
		const exclude = BoundKnapSack({
			values,
			weights,
			n: n - 1,
			target,
			lookup
		});
		lookup.set(key, include.total > exclude.total ? include : exclude);
	}
	return lookup.get(key);
}
export { BoundKnapSack };

//# sourceMappingURL=index118.js.map